<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Настройки телеграм уведомлений</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-model.number="partnerTelegramBotSettings.notification_delay"
                            label="Задержка повтора уведомления о непринятом заказе (в секундах)*"
                            placeholder="Задержка"
                        />
                        <CInput
                            v-model.number="partnerTelegramBotSettings.try_count"
                            label="Макс. кол-во уведомлений о непринятом заказе*"
                            placeholder="Кол-во уведомлений"
                        />
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { ORDER_TYPE } from '@/utils/order';

    export default {
        name: 'GrocerPartnerBotSettings',

        data() {
            return {
                partnerTelegramBotSettings: {
                    id: null,
                    entity_type: ORDER_TYPE.GROCER_DELIVERY,
                    entity_code: null,
                    notification_delay: null,
                    try_count: null,
                },
            };
        },

        mounted() {
            Vue.axios
                .get(`/default-settings/partner-telegram-bot/${ORDER_TYPE.GROCER_DELIVERY}/static`)
                .then(resp => {
                    if (resp.data.id) {
                        this.partnerTelegramBotSettings = resp.data;
                    }
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            save() {
                if (this.partnerTelegramBotSettings.notification_delay && !this.partnerTelegramBotSettings.try_count) {
                    this.$root.$emit('showError', 'Заполните макс. кол-во уведомлений!');
                    return;
                }
                if (this?.partner?.notification_delay && this?.partner?.notification_delay < 20) {
                    this.$root.$emit('showError', 'Задержка повтора уведомлений не может быть меньше чем 20 сек.');
                    return;
                }
                if (!this.partnerTelegramBotSettings.notification_delay && this.partnerTelegramBotSettings.try_count) {
                    this.$root.$emit('showError', 'Заполните задержку повтора уведомлений!');
                    return;
                }
                this.partnerTelegramBotSettings.notification_delay = this.partnerTelegramBotSettings.notification_delay ? +this.partnerTelegramBotSettings.notification_delay : null;
                this.partnerTelegramBotSettings.try_count = this.partnerTelegramBotSettings.try_count ? +this.partnerTelegramBotSettings.try_count : null;
                
                Vue.axios
                    .post('/default-settings/partner-telegram-bot/', this.partnerTelegramBotSettings)
                    .then(() => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            goBack() {
                this.$router.push({ path: '/settings/grocers' });
            },
        },
    };
</script>

<style>
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
  padding: 7px;
  border-radius: 4px;
}
</style>
